// options used throughout the app

export const backgroundColor = '#7ccaa0' // soccer pitch green
export const lineControlStyles = {
  radius: 18,
  fill: 'transparent',
  stroke: '#fff',
  strokeWidth: 3,
  opacity: 0.5,
}
export const highlightStyle = {
  stroke: '#fff',
  strokeWidth: 3,
}
export const emptyStyle = {
  strokeWidth: 0,
}

// canvas size. note that this must also match whats in variables.scss
export const canvasWidth = 615
export const canvasHeight = 630

// options for active object styling
export const lineControlFadeTransitionLength = 200
export const scaleTransitionLength = 150
export const hoverScale = 1.15

export const alternateIconColor = '#333'



// WEBPACK FOOTER //
// ./src/Tekentool/options.js